import React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
const InfoTooltip = ({sx}) => {
  return (
    <Tooltip title="Invalid Vin Number" placement="top">
      <InfoIcon sx={{ ...sx, cursor: 'pointer' }}  />
    </Tooltip>
  );
};
export default InfoTooltip;
 